import React from 'react';
import companyGeneralDataReducer from '../../redux/companyGeneralData';
import withReducers from '../../store/withReducers';
import useCompanyGeneralData from './hooks/useCompanyGeneralData';
import moment from 'moment';
import { UsersIcon } from '@commonsku/styles';

function AdminBillingRenewalSummary({ title }) {
    const { data: { data } } = useCompanyGeneralData();
    let summary: string;
    const nextAction = data.churning ? 'end' : 'automatically renew';
    const nextActionDate = data.churning ?? data.renewal_date;

    summary = `Your contract will ${nextAction} on ${moment(nextActionDate).format("MMM [1st] YYYY")}`;
    
    return (
        <div style={{ display: 'flex' }}>
            <div><UsersIcon size='large' mr={16} color='#DAE9EE' /></div>
            <div>
                <h5>{title}</h5>
                <p className='tile-summary-content'>{summary}</p>
            </div>
        </div>
    );
}

export default withReducers(AdminBillingRenewalSummary, {
    companyGeneralData: companyGeneralDataReducer,
});
